import { useState } from 'react';
import { SiteFeedbackModal } from '~/modules/site-feedback/component/SiteFeedbackModal';
import { useSiteFeedback } from '~/modules/site-feedback/hook/use-site-feedback';
import { IslandTooltip } from './IslandTooltip';

const LABEL = 'Leave Feedback for this Page';

/**
 * The staff island's last control: a black circle with the speech bubble,
 * opening the same feedback form the floating Feedback pill does on smaller
 * screens. Black, where the tools beside it are white, because it is not a
 * tool on this item but a word about the page.
 */
export const FeedbackIslandButton = () => {
    const [open, setOpen] = useState(false);
    const { submit, submitting } = useSiteFeedback();

    return (
        <>
            <IslandTooltip label={LABEL}>
                <button
                    type="button"
                    aria-label={LABEL}
                    onClick={() => setOpen(true)}
                    // size-12: the avatar's square48, so the three circle kinds in
                    // the row stand the same height.
                    className="flex size-12 shrink-0 cursor-pointer items-center justify-center bg-[#181818] text-white shadow-[0_2px_8px_rgba(0,0,0,0.1)] transition-colors focus-ring-on-dark hover:bg-[#343434]"
                >
                    <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        aria-hidden="true"
                        className="size-5"
                    >
                        <path
                            d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.9 9.9 0 0 1-3.2-.5L3 21l1.6-4.3A8.2 8.2 0 0 1 3.6 11.5a8.4 8.4 0 0 1 9-8.4 8.4 8.4 0 0 1 8.4 8.4Z"
                            stroke="currentColor"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </IslandTooltip>
            <SiteFeedbackModal
                open={open}
                onOpenChange={setOpen}
                onSubmit={submit}
                submitting={submitting}
            />
        </>
    );
};
